import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getPrimaryTransactionService = (
  page,
  limit,
  sortField,
  sortType,
  search,
  userId,
  propertyId,
  filterBy,
  filterValues
) => {
  let queryString = '';

  queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  queryString = propertyId
    ? `${queryString}&propertyId=${propertyId}`
    : queryString;
  queryString = filterBy
    ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
      filterValues
    )}`
    : queryString;

  return realBricksApi.get(
    `${API_ENDPOINTS.TRANSACTIONS.PrimaryTransactions}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const getSecondaryTransactionService = (
  page,
  limit,
  sortField,
  sortType,
  search,
  userId,
  propertyId,
  filterBy,
  filterValues
) => {
  let queryString = '';

  queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  queryString = propertyId
    ? `${queryString}&propertyId=${propertyId}`
    : queryString;
  queryString = filterBy
    ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
      filterValues
    )}`
    : queryString;

  return realBricksApi.get(
    `${API_ENDPOINTS.TRANSACTIONS.SecondaryTransactions}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const getPendingTransactionService = (
  page,
  limit,
  sortField,
  sortType,
  search,
  userId,
  propertyId,
  filterBy,
  filterValues
) => {
  let queryString = '';

  queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  queryString = propertyId
    ? `${queryString}&propertyId=${propertyId}`
    : queryString;
  queryString = filterBy
    ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
      filterValues
    )}`
    : queryString;

  return realBricksApi.get(
    `${API_ENDPOINTS.TRANSACTIONS.PendingTransactions}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const getCancelledTransactionService = (
  page,
  limit,
  sortField,
  sortType,
  search,
  userId,
  propertyId,
  filterBy,
  filterValues
) => {
  let queryString = '';

  queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  queryString = propertyId
    ? `${queryString}&propertyId=${propertyId}`
    : queryString;
  queryString = filterBy
    ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
      filterValues
    )}`
    : queryString;

  return realBricksApi.get(
    `${API_ENDPOINTS.TRANSACTIONS.CancelTransactions}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const getWithdrawalTransactionService = (
  page,
  limit,
  sortField,
  sortType,
  search,
  userId,
  propertyId,
  filterBy,
  filterValues,
  isWithdrawalApproved
) => {
  let queryString = '';

  queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  queryString = propertyId
    ? `${queryString}&propertyId=${propertyId}`
    : queryString;
  queryString = filterBy
    ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
      filterValues
    )}`
    : queryString;

  return realBricksApi.get(
    `${API_ENDPOINTS.TRANSACTIONS.WithdrawalTransactions}?page=${page}&limit=${limit}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const approveTransactions = (transactionId) => {
  return realBricksApi.put(
    `${API_ENDPOINTS.TRANSACTIONS.ApproveTransactions}/${transactionId.id}`
  );
};

export const downloadTransactionService = (
  transactionName,
  sortField,
  sortType,
  search,
  userId,
  propertyId,
  filterBy,
  filterValues
) => {
  let queryString = '';

  queryString = userId ? `${queryString}&userId=${userId}` : queryString;
  queryString = propertyId
    ? `${queryString}&propertyId=${propertyId}`
    : queryString;
  queryString = filterBy
    ? `${queryString}&filterBy=${filterBy}&filterValues=${JSON.stringify(
      filterValues
    )}`
    : queryString;

  // sortField=${sortField}&sortType=${sortType}
  return realBricksApi.get(
    `${API_ENDPOINTS.TRANSACTIONS.DownloadTransactions}/${transactionName}?${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};
